export const practiceTeamsPath = () => window.Routes.practice_teams_path();
export const practiceTeamPath = (practiceTeamId) => window.Routes.practice_team_path(practiceTeamId);
export const editPracticeTeamPath = (practiceTeamId) => window.Routes.edit_practice_team_path(practiceTeamId);

export const goTo = (path) => window.location.replace(path);

export const goToPracticeTeams = () => goTo(practiceTeamsPath());
export const goToPracticeTeam = (practiceTeamId) => goTo(practiceTeamPath(practiceTeamId));
export const goToEditPracticeTeam = (practiceTeamId) => goTo(editPracticeTeamPath(practiceTeamId));
